(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  function initializeMobileNavigation() {
    document.querySelectorAll('[data-mobile-navigation]').forEach((navigation) => {
      const summary = navigation.querySelector('summary');
      if (!summary) return;

      const syncState = () => {
        summary.setAttribute('aria-expanded', navigation.open ? 'true' : 'false');
      };

      navigation.addEventListener('toggle', syncState);
      navigation.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          navigation.open = false;
          syncState();
        });
      });

      navigation.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !navigation.open) return;
        event.preventDefault();
        navigation.open = false;
        syncState();
        summary.focus();
      });

      document.addEventListener('pointerdown', (event) => {
        if (!navigation.open || navigation.contains(event.target)) return;
        navigation.open = false;
        syncState();
      });

      syncState();
    });
  }

  function initializeIvMenu() {
    const experience = document.querySelector('[data-iv-experience]');
    if (!experience) return;

    const grid = experience.querySelector('#iv-treatment-list');
    const status = experience.querySelector('[data-iv-status]');
    const buttons = Array.from(experience.querySelectorAll('[data-iv-goal]'));
    const cards = Array.from(experience.querySelectorAll('.iv-treatment-card'));
    const mobileToggle = experience.querySelector('[data-iv-mobile-toggle]');
    if (!grid || !status || !buttons.length || !cards.length) return;

    let activeGoal = 'all';
    let expanded = false;

    const goalLabels = {
      all: 'L1NO IV',
      hydrate: 'hydration',
      energy: 'energy & performance',
      recover: 'recovery & wellness',
      glow: 'skin & metabolic',
      advanced: 'iron & specialty',
    };

    const update = () => {
      const visibleCards = cards.filter((card) => activeGoal === 'all' || card.dataset.goal === activeGoal);
      const visibleSet = new Set(visibleCards);

      cards.forEach((card) => {
        const visible = visibleSet.has(card);
        card.hidden = !visible;
        card.toggleAttribute('data-mobile-hidden', visible && visibleCards.indexOf(card) >= 6);
        if (!visible) {
          card.querySelectorAll('details[open]').forEach((details) => {
            details.open = false;
          });
        }
      });

      grid.dataset.count = String(visibleCards.length);
      grid.dataset.mobileExpanded = expanded ? 'true' : 'false';
      grid.dataset.filterActive = activeGoal === 'all' ? 'false' : 'true';
      status.textContent = `${visibleCards.length} ${goalLabels[activeGoal]} options available.`;

      buttons.forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.ivGoal === activeGoal ? 'true' : 'false');
      });

      if (mobileToggle) {
        mobileToggle.hidden = visibleCards.length <= 6;
        mobileToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        mobileToggle.textContent = expanded
          ? 'Show fewer IV treatments'
          : `View all ${visibleCards.length} IV treatments`;
      }
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        activeGoal = button.dataset.ivGoal || 'all';
        expanded = false;
        update();
      });
    });

    if (mobileToggle) {
      mobileToggle.addEventListener('click', () => {
        expanded = !expanded;
        update();
      });
    }

    update();
  }

  ready(() => {
    initializeMobileNavigation();
    initializeIvMenu();
  });
})();
